import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MdbModalRef } from 'mdb5-adapted';
import { MdbRippleModule } from 'mdb5-adapted';
import { RegionModel } from 'src/app/core/models/region.model';

import { LMS_NoSpecialsDirective, LmsModalFrameComponent, UpperCaseInputDirective } from '@lmsSharedUI';

@Component({
  selector: 'app-regions-add',
  templateUrl: './regions-add.component.html',
  styleUrls: ['./regions-add.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    LmsModalFrameComponent,
    LMS_NoSpecialsDirective,
    UpperCaseInputDirective,
    NgIf,
    MdbRippleModule,
  ],
})
export class RegionsAddComponent {
  regionForm = this.fb.group({
    region: '',
  });
  submitted: boolean = false;
  regionModel = new RegionModel();
  regionNumber: any;
  public region_Ar: RegionModel;
  regionNo: any;
  area: any;

  constructor(public dialogRef: MdbModalRef<RegionsAddComponent>, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.submitted = false;

    this.regionForm.patchValue({
      region: this.regionModel.name,
    });
  }

  saveRegion() {
    this.submitted = true;
    if (!this.regionForm.valid) {
      return;
    }

    this.regionModel.name = this.regionForm?.controls?.region?.value as string;
    this.regionModel.id = 0;
    this.dialogRef.close(this.regionModel);
  }

  close() {
    this.dialogRef.close();
  }
}
